import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import { i18n } from '@/plugins/i18n'
import vuecookie from 'vue-cookies'

const state = {
    translated_words: [],
    missing_translations: [],
    allLanguageList: {},
    changeToEnglish: false,
}

const getters = {
    getTranslatedWords: (state) => state.translated_words,
    getMissingTranslationWords: (state) => state.missing_translations,
    getAllLanguageList: (state) => state.allLanguageList,
    getChangeToEnglish: (state) => state.changeToEnglish,
};

const actions = {
    async getLangTranslation(context, language) {
        await axios.get(`${backendUrl()}/getLanguageTranslations/${language.currentLang}`,
        {
            language: language,
            token: context.getters.allTemplateDetails.token
        }).then(response => {

            let curr_lang = localStorage.getItem('currentTranslation') || 'EN'

            if(curr_lang != 'EN' && response.data[curr_lang] != undefined) {
                i18n.setLocaleMessage(curr_lang,response.data[curr_lang])
            }

            i18n.setLocaleMessage('EN',response.data.EN)
            i18n.locale = curr_lang
        })
    },

    async getTranslatedWords(context, language) {
        await axios.get(`${backendUrl()}/getTranslatedWords/${language}`, {
            params: {
                token: context.getters.allTemplateDetails.token
            },
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.commit('setTranslatedWords', response.data)
        })
    },

    async updateTranslations(context, data) {
        await axios.post(`${backendUrl()}/updateTranslations`,
        {
            new_translations: data.new_translations,
            token: context.getters.allTemplateDetails.token
        }, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('getTranslatedWords',
                 data.language
            )
            context.dispatch('updateLanguageTranslations', data.language)
        })
    },

    async addNewLanguage(context, new_language) {
        await axios.post(`${backendUrl()}/addNewLanguage`,
        {
            new_language: new_language,
            token: context.getters.allTemplateDetails.token
        },
        {
        headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response)
            context.dispatch('getLanguageList')
            context.dispatch('getAllLanguageList', response)
        })
    },
    async editLanguage(context, data) {
        await axios.post(`${backendUrl()}/editLanguage`,
        {
            language_id: data.language_id,
            activate: data.active,
            language_code: data.language_code
        },
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            //if the currentLanguage has setted up to inactive then change to English
            if(localStorage.getItem('currentTranslation') == data.language_code && response.data.active == 0){
                context.commit('setChangeToEnglish', true)
                i18n.locale = 'EN'
            }
            //We update the Language list after the change of the status
            context.dispatch('getLanguageList')
            context.dispatch('handleResponse', response)
            context.dispatch('getAllLanguageList')
        })
    },

    async updateLanguageNameCode(context, data) {
        await axios.post(`${backendUrl()}/updateLanguageNameCode`,
        {
            languageId: data.languageId,
            languageName: data.languageName,
            languageCode: data.languageCode
        },
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('getAllLanguageList')
            context.dispatch('getLanguageList')
            context.dispatch('handleResponse', response)
        })
    },

    async deleteLanguage(context, data) {
        await axios.post(`${backendUrl()}/deleteLanguage`,
        {
            language_id: data.language_id
        },
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            //if the currentLanguage has been deleted then change to English
            if(localStorage.getItem('currentTranslation') == data.language_code) {
                context.commit('setChangeToEnglish', true)
                i18n.locale = 'EN'
            }
            //We update the Language and the translations lists after the deletion of the selected language
            context.dispatch('getLanguageList')
            context.dispatch('getAllLanguageList', response)
            context.dispatch('handleResponse', response)
            context.dispatch('getTranslatedWords', data.language_code)
        })
    },

    async addNewTranslationKey(context, new_translation_key) {
        await axios.post(`${backendUrl()}/addNewTranslationKey`,
        {
            new_translation_key: new_translation_key,
            token: context.getters.allTemplateDetails.token
        }, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response)
            //update that language with new key
            context.dispatch('updateLanguageTranslations',new_translation_key.language)
        })
    },

    async updateLanguageTranslations(context, updated_language)
    {
        await axios.post(`${backendUrl()}/getUpdatedLangTranslations`,
        {
            language: updated_language,
            token: context.getters.allTemplateDetails.token
        },{
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            // update translations object after adding a new translation key
            i18n.setLocaleMessage(response.data.language,response.data.translations[response.data.language])
        })
    },

    async getLanguageList(context) {
        await axios.get(`${backendUrl()}/getLanguageList`)
        .then(response => {
            // after adding a language make sure the stores language list is updated
            context.commit('setLanguageList', response.data)
            localStorage.setItem('languageList' , JSON.stringify(response.data))
        })
    },

    async getAllLanguageList(context) {
        await axios.get(`${backendUrl()}/getAllLanguageList`,{
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.commit('setAllLanguageList', response.data)
        })
    },

    async getMissingTranslations(context, language) {
        await axios.get(`${backendUrl()}/getMissingTranslations/${language}`, {
            params: {
                token: context.getters.allTemplateDetails.token
            },
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.commit('setMissingTranslationWords', response.data)
        })
    },

    async getClientTranslations(context, data) {
        return await axios.post(`${backendUrl()}/getClientTranslations`, {
            language: data.language,
            client: data.client
        }, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async createClientComparedTranslations(context, data) {
        return await axios.post(`${backendUrl()}/createClientComparedTranslations`, {
            language: data.selectedLanguage,
            translations: data.newTranslations
        }, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.dispatch('updateLanguageTranslations', response.data.updatedLangTranslations)
            context.dispatch('handleResponse', response)
            return response.data
        })
    },

    async autoPopulateTranslations(context, data) {
        return await axios.post(`${backendUrl()}/autoPopulateTranslations`, {
            language: data.selectedLanguage,
        }, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            context.dispatch('updateLanguageTranslations', response.data.updatedLangTranslations)
            context.dispatch('handleResponse', response)
            return response.data
        })
    },

    async createMissingTranslations(context, translations) {
        await axios.post(`${backendUrl()}/createMissingTranslations`,
        {
            missing_translations: translations.missing_translations,
            language: translations.language,
            token: context.getters.allTemplateDetails.token
        },{
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('updateLanguageTranslations',response.data.new_translations_language)
            context.dispatch('getMissingTranslations',response.data.new_translations_language)
        })
    },

    async deleteTranslation(context, data) {
        await axios.post(`${backendUrl()}/deleteTranslation`,
        {
            translation_id: data.translation,
            token: context.getters.allTemplateDetails.token
        },{
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('getTranslatedWords', data.langCode)
            context.dispatch('handleResponse', response)
        })
    },

    async exportMissingTransCSV(context, data) {
        return axios.post(`${backendUrl()}/exportMissingTransToCSV`, data, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {

            return response.data.dataDownloadUrl
        })
    },

    async exportTranslationsCsv(context, data) {
        return axios.post(`${backendUrl()}/exportTranslationsToCsv`, data, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {

            return response.data.dataDownloadUrl
        })
    },

    async updateTranslationsByCsv(context, data) {
      axios.post(`${backendUrl()}/updateTranslationsByCsv`, data,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': "bearer " +  vuecookie.get('token')
          }
        }).then(response => {
          context.dispatch('handleResponse', response)
          context.dispatch('updateLanguageTranslations', response.data.updatedLanguage)
        })
    }
};

const mutations = {
    setTranslatedWords:(state, translated_words) => (state.translated_words = translated_words),
    setMissingTranslationWords: (state, missing_translations) => (state.missing_translations = missing_translations),
    setAllLanguageList: (state, AlllanguageList) => (state.allLanguageList = AlllanguageList),
    setChangeToEnglish: (state, changeToEnglish) => (state.changeToEnglish = changeToEnglish),
};

export default {
  state,
  getters,
  actions,
  mutations
}
